/* ===================================================================
   Chez Meima — interactions
=================================================================== */
(function () {
  'use strict';

  /* ---------- Année footer ---------- */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ---------- Header : ombre au scroll ---------- */
  var header = document.getElementById('header');
  window.addEventListener('scroll', function () {
    header.classList.toggle('scrolled', window.scrollY > 20);
  });

  /* ---------- Menu mobile ---------- */
  var burger = document.getElementById('burger');
  var nav = document.getElementById('mainNav');
  var navBackdrop = document.getElementById('navBackdrop');

  function setNav(open) {
    nav.classList.toggle('open', open);
    burger.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    document.body.classList.toggle('no-scroll', open);
    if (open) {
      navBackdrop.hidden = false;
      // force reflow pour déclencher la transition d'opacité
      void navBackdrop.offsetWidth;
      navBackdrop.classList.add('show');
    } else {
      navBackdrop.classList.remove('show');
      setTimeout(function () { navBackdrop.hidden = true; }, 300);
    }
  }
  function closeNav() { setNav(false); }

  burger.addEventListener('click', function () {
    setNav(!nav.classList.contains('open'));
  });
  navBackdrop.addEventListener('click', closeNav);
  nav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeNav);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('open')) closeNav();
  });

  /* ---------- Révélation au scroll ---------- */
  var revealTargets = document.querySelectorAll(
    '.valeur-card, .dish, .g-item, .avis-card, .histoire-text, .histoire-media, .commander-text, .promo-aside, .traiteur-text, .quote-form, .infos-card, .infos-map, .menu-note'
  );
  revealTargets.forEach(function (el) { el.classList.add('reveal'); });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealTargets.forEach(function (el) { io.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('in'); });
  }
})();
